import { useState } from 'react';
import imageUpload from 'api/requests/imageUpload';
import validateInputFile from 'helpers/validate-input-file';

const IMAGE_FOLDER = 'image_description_with_html';

/**
 * Sobe as imagens que o produtor insere no editor de texto formatado.
 *
 * O editor mostra a imagem na hora (base64) e chama `upload`; quando o envio
 * termina, `uploads` traz a URL definitiva e o editor troca o base64 por ela.
 * Os quatro retornos são exatamente as props de imagem do RichTextEditor.
 */
export default function useRichTextImageUpload() {
    const [uploads, setUploads] = useState([]);
    const [error, setError] = useState('');

    async function upload(file, uploadId) {
        const validation = validateInputFile(file);

        if (!validation.isValid) {
            setError(validation.message);
            return;
        }

        const formData = new FormData();
        formData.append('image', file);
        formData.append('folder', IMAGE_FOLDER);

        try {
            const { data } = await imageUpload.uploadWithFolder(formData);
            setUploads(previous => [...previous, { uploadId, path: data?.path }]);
        } catch {
            setError('Não foi possível enviar a imagem. Remova-a do texto e tente de novo.');
        }
    }

    return { uploads, error, setError, upload };
}
